import { errorStatuses } from '@/utils/consts/statuses';
import { AxiosResponse } from 'axios';

export const copyObject = (el: any) => {
  if (window && typeof structuredClone === 'function') {
    try {
      return structuredClone(el);
    } catch (error) {
      return JSON.parse(JSON.stringify(el));
    }
  }
  return JSON.parse(JSON.stringify(el));
};

function getMessageByErrorCode(status: number | undefined): string {
  //@ts-ignore
  return status ? errorStatuses[status] || 'Неизвестная ошибка' : 'Проблема связанная с сетью';
}

export function getError(response: AxiosResponse): string {
  const { message, errorMessage } = response.data;
  return (
    message ||
    errorMessage ||
    (typeof response?.data === 'string' ? response?.data : getMessageByErrorCode(response.status))
  );
}
